import { Chip } from '@mui/material';
import { useState } from 'react';
import { toast } from 'material-react-toastify';
import { FilterValue } from '../../interfaces/ProductFilter/FilterValue';
import { Waiting } from '../../components/Waiting/Waiting';
import { deleteFilterValue } from '../../api/ProductFilter';
import ConfirmDialog from '../../components/ConfirmDialog/ConfirmDialog';

type FilterValueChipProps = {
  keyID: number;
  filterValue: FilterValue;
  selectedLocale: string | null;
  allowDelete: boolean;
  onModify: () => void;
  onClick: () => void;
};

export const FilterValueChip = (props: FilterValueChipProps) => {
  const [loading, setLoading] = useState(false);
  const [clickedDelete, setClickedDelete] = useState(false);

  const handleDelete = () => {
    setClickedDelete(false);
    setLoading(true);
    deleteFilterValue(props.filterValue.id)
      .then(() => {
        toast.success('Değer başarıyla silindi');
        props.onModify();
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  const resolvedTitle = props.selectedLocale
    ? props.filterValue.titleTranslation[props.selectedLocale] ??
      props.filterValue.title
    : props.filterValue.title;

  return (
    <>
      {clickedDelete && (
        <ConfirmDialog
          content='Gerçekten seçili değeri silmek istiyor musunuz'
          open={clickedDelete}
          onClose={() => setClickedDelete(false)}
          onConfirm={handleDelete}
          color='error'
        />
      )}
      <Waiting open={loading} />
      <Chip
        label={resolvedTitle}
        color={
          props.selectedLocale &&
          !props.filterValue.titleTranslation[props.selectedLocale]
            ? 'error'
            : 'primary'
        }
        onClick={props.onClick}
        onDelete={props.allowDelete ? () => setClickedDelete(true) : undefined}
      />
    </>
  );
};
